export default __webpack_public_path__ + "static/article-travel-bucketlist-61284c3acaf7fdb7b6619764dc07e0de.jpg";